import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import CordwoodHistoryName from "../../components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryName.tsx";
import {useLocationFormState} from "../../components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryUpdateForm";
import CordwoodHistoryUpdateFormProvider from "../../components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CordwoodHistoryUpdateEditPage = () => {
    
    useTitle(t`Update Cordwood History`);

    const { cordwoodHistoryId: id } = useParams();
    
    return (
        <Box data-testid="CordwoodHistory-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="CordwoodHistory-update-title"
                    >
                        <Trans>Edit Cordwood History</Trans>:  <CordwoodHistoryName id={id}/>
                    </Typography>
                    <CordwoodHistoryUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default CordwoodHistoryUpdateEditPage;
